{
  "name": "04  clock magnet",
  "title": "ClockMagnet",
  "description": "ClockMagnetDescription",
  "stat": 2,
  "boughtEarlyStat": 54,
  "inventoryStat": 16,
  "lockFlag": 16
}